// Central brand configuration. Change values here to rebrand the entire app.
export const BRAND = {
  name: 'casahom',
  legalName: 'Casahom LLC',
  tagline: 'Find a place you\u2019ll love to call home',
  logoInitial: 'C',
  // Google Maps JS API key is read from the frontend .env file.
  // Add REACT_APP_GOOGLE_MAPS_API_KEY to /app/frontend/.env to enable Google Maps.
  // Without a key the app gracefully falls back to a free Leaflet/OpenStreetMap map.
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  support: {
    email: 'info@casahom.com',
    // Set REACT_APP_SUPPORT_PHONE in .env; omit from UI when unset (no fake placeholder).
    phone: (process.env.REACT_APP_SUPPORT_PHONE || '').trim(),
  },
  address: {
    line1: '20376 Hacienda Ct',
    city: 'Boca Raton',
    state: 'FL',
    zip: '33498',
    lat: 26.371428,
    lng: -80.223171,
  },
  hours: 'Monday–Friday, 9:00 AM – 6:00 PM ET',
  social: ['Facebook', 'Twitter', 'Instagram', 'LinkedIn'],
};

export const PANEL_URL = 'https://app.casahom.com/panel/explorer';

export const COLORS = {
  primary: '#007AFF',
  primaryDark: '#0066CC',
  primaryLight: '#3395FF',
  accentSky: '#E0F2FE',
  accentHover: '#FF9500',
  success: '#10B981',
  amber: '#FF9500',
};
